import React from 'react';
import { faLightbulbOn } from '@fortawesome/pro-regular-svg-icons/faLightbulbOn';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function LightBulbRegularIcon(props) {
  return <FontAwesomeIcon icon={faLightbulbOn} {...props} />;
}
